import OfferCard from "./OfferCard";
import { Offer, Promoter } from "../../types";

import styles from "./offers.module.scss";

export default function Offers({
  cityName,
  allOffers,
}: {
  cityName: string;
  allOffers: { promoter: Promoter; offers: Offer[] }[];
}) {
  
  return (
    <div className={styles.pageContainer}>
      <div className={styles.line} />
      <h3 className={styles.title}>Offers</h3>
      <div className={styles.gradientLine} />
      <div className={styles.offerCardContainer}>
        {allOffers.map((el) => (
          <div key={el.offers[0].id} className={styles.offerCardBox}>
            <OfferCard promoterOffers={el} cityName={cityName} />
          </div>
        ))}
      </div>
    </div>
  );
}
